import { createFileRoute } from "@tanstack/react-router";
import { getAssetsRetrieveQueryOptions } from "@/api/wai/wai3Api";
import { AssetDescriptionBox } from "@/components/Map/components/AssetDescriptionBox";

export const Route = createFileRoute("/_auth/kart/asset/$assetName")({
  loader: async ({ params: { assetName }, context: { queryClient } }) => {
    await queryClient.query(getAssetsRetrieveQueryOptions(assetName));
  },

  component: AssetDescriptionBox,
});
